import { render, staticRenderFns } from "./Sets.vue?vue&type=template&id=a23ed49a&scoped=true"
import script from "./Sets.vue?vue&type=script&lang=ts"
export * from "./Sets.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ed49a",
  null
  
)

export default component.exports